import { ajaxService, urlService } from "../services";

export async function authUser() {
    ajaxService.removeDependency()
    return ajaxService.get(urlService.user).then(response => {
        return response.data;
    })
}

